import { render, staticRenderFns } from "./OverlaySpinner.vue?vue&type=template&id=3b04157d&scoped=true&"
import script from "./OverlaySpinner.vue?vue&type=script&lang=js&"
export * from "./OverlaySpinner.vue?vue&type=script&lang=js&"
import style0 from "./OverlaySpinner.vue?vue&type=style&index=0&id=3b04157d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b04157d",
  null
  
)

export default component.exports